const Services = () => {
    return ( 
        <div className="Services">
        <div class="section techwix-choose-us-section techwix-choose-us-section-04 section-padding">
            <div class="container">
                <div class="choose-us-wrap">
                    <div class="choose-us-content-wrap">
                        <div class="row" style={{textAlign: "left"}}>
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="choose-us-item-02">
                                    <div class="choose-us-img">
                                        <img src="assets/images/ser-icon22.png" alt="" />
                                    </div>
                                    <div class="choose-us-content">
                                        <h3 class="title"><a href="#">Software Development</a></h3>
                                        <p>We create software that ranges from fleet management to inventory management to full-fledged ERP packages.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="choose-us-item-02">
                                    <div class="choose-us-img">
                                        <img src="assets/images/counter-3.png" alt="" />
                                    </div>
                                    <div class="choose-us-content">
                                        <h3 class="title"><a href="#">Data Science & Analysis</a></h3>
                                        <p>Get the predictive insights and risk analytics to make your global supply chain faster, smarter, leaner, and more sustainable</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="choose-us-item-02">
                                    <div class="choose-us-img">
                                        <img src="assets/images/ser-icon10.png" alt="" />
                                    </div>
                                    <div class="choose-us-content">
                                        <h3 class="title"><a href="#">IT Consultancy & solution</a></h3>
                                        <p>Accelerate your business with our IT consultancy and solutions expertise. Unlock growth and innovation.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="choose-us-item-02">
                                    <div class="choose-us-img">
                                        <img src="assets/images/ser-icon11.png" alt="" />
                                    </div>
                                    <div class="choose-us-content">
                                        <h3 class="title"><a href="#">Cloud managed services</a></h3>
                                        <p>Elevate your business with our Managed Cloud Services: Experience seamless scalability, security & support.</p>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section techwix-cta-section-04 techwix-cta-section-06 techwix-cta-section-07" style={{marginBottom: "230px"}}>
            <div class="container">
                <div class="cta-wrap" style={{backgroundImage: "url(assets/images/bg/cta-bg5.jpg)"}}>
                    <div class="row align-items-center">
                        <div class="col-lg-7">
                            <div class="cta-left">
                                <div class="section-title">
                                    <h2 class="title white" style={{textAlign: "left"}}>To make requests for further information, contact us </h2>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="cta-info text-center">
                                <div class="cta-icon">
                                    <img src="assets/images/cta-icon2.png" alt="" />
                                </div>
                                <div class="cta-text">
                                    <p>Call Us For Any inquiry</p>
                                    <h3 class="number">(+234) 903 822 4320</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
     );
}
 
export default Services;